import { createContext, useContext } from "react";

const TimeRecordModalContext = createContext({});

export const useTimeRecordModalContext = () => useContext(TimeRecordModalContext);

export default TimeRecordModalContext;
